import {
  Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy,
  ChangeDetectorRef, ViewChildren, ElementRef, QueryList
} from '@angular/core';
import * as moment from 'moment';
import {
  NEGOCIO_TYPE_INTENCION, NEGOCIO_TYPE_INTENCION_ID, NEGOCIO_TYPE_ORDEN,
  NEGOCIO_TYPE_ORDEN_ID
} from '../../../../services/negocios-service';
import { PermisosService, NEG_ACTIONS } from '../../../../services/permisos-service';
import {PATH_CUENTA_DETAIL, PATH_NEGOCIO_DETAIL} from '../../../../navigation/navigation.module';
import { Router } from '@angular/router';
import { DialogsService, SpinnerService, NegociosService, CONFIRMACION_VALUES } from '../../../../services';


@Component({
  selector: 'app-negocio-kanban-card',
  templateUrl: './negocio-kanban-card.component.html',
  styleUrls: ['./negocio-kanban-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NegocioKanbanCardComponent implements OnInit {

  private negocios = [];

  @Input()
  set _negocios(val: any) {
    this.negocios = val;
    this.negocios.forEach(negocio => {

      negocio['showDetails'] = false;

      if (negocio.Entrega.EsPosicion) {
        negocio['entrega'] = negocio.NegocioTipoPosicion.NegocioTipoPosicion[0].toUpperCase() + negocio.NegocioTipoPosicion.NegocioTipoPosicion.substr(1);
      } else if (negocio.Entrega.Entrega === 'Pago Diferido') {
        negocio['entrega'] = 'Pago Diferido ' + negocio.NegocioTipoPosicion.NegocioTipoPosicion;
      } else {
        negocio['entrega'] = negocio.Entrega.Entrega;
      }

      negocio['highLight'] = negocio.PrecioEspecial !== 0 || negocio.Confirmacion.Estado !== CONFIRMACION_VALUES.ACTIVA;

      if (negocio.Confirmacion.Estado !== CONFIRMACION_VALUES.ACTIVA) {
        negocio['precioIdea'] = negocio.PrecioEspecial !== 0 ? negocio.PrecioEspecial : negocio.Base;
      } else {
        negocio['precioIdea'] = 0;
      }

      negocio['fechaCreacion'] = moment(negocio.Fecha * 1000).format('DD/MM/YYYY HH:mm');

      negocio['fechaVencimiento'] = moment(negocio.Vencimiento * 1000).format('DD/MM/YYYY HH:mm');

      negocio['marcaTemporal'] = moment.unix(negocio.FechaModificacion).format('DD/MM/YYYY HH:mm');

      if (negocio.Confirmacion) {
        let name = negocio.Confirmacion.Estado.split(' ').map(w => w.toLowerCase()).slice(0, 2).join('-');
        // El color para estos dos estados difieren en caso de que sea una intención o una orden
        negocio['estadoClass'] = (name === 'vencida' || name === 'activa') && negocio.TipoNegocio.Tipo === NEGOCIO_TYPE_INTENCION ? name += '2' : name;
      }

      negocio['idInfo'] = `Id: ${negocio.Id}`;

    });
    this.cdr.detectChanges();
  }

  @Output() negocioUpdated = new EventEmitter<{}>();

  @Input() showVencimiento = false;

  @Input() showNegId = false;

  public NEG_ACTIONS = NEG_ACTIONS;
  public performingAction = false;
  private CONFIRMACION_VALUES = CONFIRMACION_VALUES;

  private showPopupFlag = false;
  private preventDetails = false;

  constructor(private permisosService: PermisosService,
              private router: Router,
              private dialogsService: DialogsService,
              private spinnerService: SpinnerService,
              private negociosService: NegociosService,
              private cdr: ChangeDetectorRef) { }

  ngOnInit() {
  }

  onPerfomAction(action, i) {
    switch (action) {
      case this.NEG_ACTIONS.CONSULTAR:
        this.router.navigate([PATH_NEGOCIO_DETAIL, this.negocios[i].Id]);
        break;

      case this.NEG_ACTIONS.EDITAR:
        this.dialogsService.showNewNegocioDialog(this.negocios[i].Id)
          .subscribe(value => {
            if (value) {
              this.negocioUpdated.emit({});
            }
          });
        break;

      case this.NEG_ACTIONS.DUPLICAR:
        this.dialogsService.showNewNegocioDialog(this.negocios[i].Id, true)
          .subscribe( (value) => {
            if (value) {
              this.negocioUpdated.emit({});
            }
          });
        break;

      case this.NEG_ACTIONS.CAMBIAR_TIPO:
        this.dialogsService.confirm(null,
          '¿Está seguro de que quiere cambiar el tipo de este negocio?',
          'SÍ, CAMBIAR',
          'NO, CANCELAR')
          .subscribe( res => {
            if (res) {
              // Cambiar el tipo de negocio en la API
              this.spinnerService.setShowFlag(true);
              this.negociosService.swapNegocioType(this.negocios[i].Id).subscribe(x => {
                // Y en el listado
                if (this.negocios[i].TipoNegocio.Tipo === NEGOCIO_TYPE_INTENCION) {
                  this.negocios[i].TipoNegocio.Tipo = NEGOCIO_TYPE_ORDEN;
                  this.negocios[i].TipoNegocio.Id = NEGOCIO_TYPE_ORDEN_ID;
                } else {
                  this.negocios[i].TipoNegocio.Tipo = NEGOCIO_TYPE_INTENCION;
                  this.negocios[i].TipoNegocio.Id = NEGOCIO_TYPE_INTENCION_ID;
                }
                this.spinnerService.setShowFlag(false);
              }, err => this.spinnerService.setShowFlag(false));
              this.cdr.detectChanges();
            }
          });
        break;

      case this.NEG_ACTIONS.ANULAR:
        this.dialogsService.showTextAreaDialog(
          '¿Está seguro de que desea anular este negocio?', null,
          'SÍ, ANULAR',
          'NO, CANCELAR', true)
          .subscribe(res => {
            if (res) {
              this.spinnerService.setShowFlag(true);
              this.negociosService.deleteNegocio(this.negocios[i].Id, res).subscribe(_ => {
                this.negocioUpdated.emit({});
                this.spinnerService.setShowFlag(false);
              }, err => this.spinnerService.setShowFlag(false));
            }
          });
        break;
    }
    this.cdr.detectChanges();
  }

  showAction(action, i) {
    return this.negocios[i] ? this.permisosService.showNegocioAction(action, this.negocios[i].Confirmacion.Estado, this.negocios[i].TipoNegocio.Id) : false;
  }

  getOppositeType(i) {
    return this.negocios[i].TipoNegocio.Tipo === NEGOCIO_TYPE_ORDEN ? NEGOCIO_TYPE_INTENCION : NEGOCIO_TYPE_ORDEN;
  }

  toggleDetails(i) {
    if (!this.preventDetails) {
      this.negocios[i].showDetails = !this.negocios[i].showDetails;
      this.cdr.detectChanges();
      this.preventDetails = true;
      setTimeout(() => {
        this.preventDetails = false;
      }, 10);
    }

  }

  toggleDetailsNoRules(i) {
    this.negocios[i].showDetails = !this.negocios[i].showDetails;
  }

  public update() {
    this.cdr.detectChanges();
  }

  onGoToClient(negocio) {
    this.router.navigate([PATH_CUENTA_DETAIL, negocio.Cliente.Id]);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios-kanban/negocio-kanban-card/negocio-kanban-card.component.ts